module.exports = {"230381100":"虎林镇","230381101":"东方红镇","230381102":"迎春镇","230381103":"虎头镇","230381104":"杨岗镇","230381105":"东诚镇","230381106":"宝东镇","230381203":"新乐乡","230381204":"伟光乡","230381206":"珍宝岛乡","230381207":"阿北乡","230381400":"东方红林业局","230381401":"迎春林业局","230381500":"八五〇农场","230381501":"八五四农场","230381502":"八五六农场","230381503":"八五八农场","230381504":"庆丰农场","230381505":"云山农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230381.json
// module id = 802
// module chunks = 0